<template>
  <div style="height: 100%;" class="left_menu" :class="isCollapse ? 'short' : ''">

    <el-menu style="height: 100%" :default-active="pathNow" class="el-menu-vertical-demo" unique-opened
      :collapse-transition="false" :collapse="isCollapse" background-color="#f5f5f5" text-color="#fff"
      active-text-color="#fff" @open="openMenu">
      <el-submenu :collapse="false" :index="`${item.id}`" v-for="(item) in menuList" :key="item.id">
        <template slot="title">
<!--          受众-->
          <img v-if="item.text === '终端店'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_shop1.png'):require('../../assets/images/menu/audit_shop.png')">
          <img v-else-if="item.text === '客户'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_costom1.png'):require('../../assets/images/menu/audit_costom.png')">
          <img v-else-if="item.text === '经销商'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_jxs1.png'):require('../../assets/images/menu/audit_jxs.png')">

          <img v-else-if="item.text === '员工'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_costom1.png'):require('../../assets/images/menu/audit_costom.png')">
          <img v-else-if="item.text === '团购商'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_tgs1.png'):require('../../assets/images/menu/audit_tgs.png')">
          <img v-else-if="item.text === '团购会员'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_member1.png'):require('../../assets/images/menu/audit_member.png')">
          <img v-else-if="item.text === '团购KOL'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_kol1.png'):require('../../assets/images/menu/audit_kol.png')">
          <img v-else-if="item.text === '酒庄'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_wine1.png'):require('../../assets/images/menu/audit_wine.png')">
          <img v-else-if="item.text === '测试员工'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_test1.png'):require('../../assets/images/menu/audit_test.png')">
          <img v-else-if="item.text === '导出'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_export1.png'):require('../../assets/images/menu/audit_export.png')">
          <img v-else-if="item.text === '123'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_1231.png'):require('../../assets/images/menu/audit_123.png')">
<!--          场景-->
          <img v-else-if="item.text === '场景管理'"
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/a_2.png'):require('../../assets/images/menu/a_1.png')">
<!--          互动-->
            <img v-else-if="item.text === '微页面管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/hd_11.png'):require('../../assets/images/menu/hd_12.png')">

            <img v-else-if="item.text === '微信管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/hd_21.png'):require('../../assets/images/menu/hd_22.png')">

            <img v-else-if="item.text === '短信管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/hd_31.png'):require('../../assets/images/menu/hd_32.png')">

            <img v-else-if="item.text === '活码管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/hd_41.png'):require('../../assets/images/menu/hd_42.png')">

            <img v-else-if="item.text === '活动管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/hd_51.png'):require('../../assets/images/menu/hd_52.png')">

            <!--          分析-->
            <img v-else-if="item.text === '分析中心'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/fx_1.png'):require('../../assets/images/menu/fx_2.png')">

            <img v-else-if="item.text === '单图'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/dt_1.png'):require('../../assets/images/menu/dt_2.png')">

            <img v-else-if="item.text === '看板'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/kb_1.png'):require('../../assets/images/menu/kb_2.png')">

            <!--          设置-->
            <img v-else-if="item.text === '客户画像'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/kh_1.png'):require('../../assets/images/menu/kh_2.png')">

            <img v-else-if="item.text === '产品配置'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/cp_1.png'):require('../../assets/images/menu/cp_2.png')">

            <img v-else-if="item.text === '权限设置'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/qx_1.png'):require('../../assets/images/menu/qx_2.png')">

            <!--          资源-->

            <img v-else-if="item.text === '产品管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/product_1.png'):require('../../assets/images/menu/product_2.png')">

            <img v-else-if="item.text === '卡券管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/card_1.png'):require('../../assets/images/menu/card_2.png')">

            <!--          订单-->

            <img v-else-if="item.text === '订单管理'"
                 class="menuClass"
                 :src="pathNowIndex==item.id?require('../../assets/images/menu/order_1.png'):require('../../assets/images/menu/order_2.png')">


            <img v-else
               class="menuClass"
               :src="pathNowIndex==item.id?require('../../assets/images/menu/audit_test1.png'):require('../../assets/images/menu/audit_test.png')">

          <span>{{item.text}}</span>
        </template>
        <el-menu-item :index="menu.attributes.route" v-for="menu in item.children" :key="menu.attributes.route"
          @click.native="changeSubmenu(menu.attributes.route, item.id)">
          {{menu.text}}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { getCusTypes } from '@/api/set.js'
export default {
  name: 'setCenterLeft',
  props: {
    isOpen: Boolean,
    topCurrentPath: String,
  },
  data () {
    return {
      isCollapse: this.isOpen,
      leftMenuList: Lockr.get('menuList'),
      menuList: Lockr.get('menuList')[0].children,
      audiences: '/home/audiences-manage',
      pathNow: '',
      pathNowIndex: '', // 打开的当前下标
    }
  },
  computed: {},
  watch: {
    $route (to, from) {
      // console.log(to, '监听路由变化')
      this.pathNow = to.path
      this.pathNowIndex = Lockr.get('pathNowIndex')
      sessionStorage.setItem('leftPath', to.path)
    },
    isOpen: function (val) {
      this.isCollapse = val
    },
    // 当头部切换菜单时，重新渲染左侧列表
    topCurrentPath: {
      handler (val) {
        this.handlePath(val)
        return val
      },
      deep: true,
      immediate: true,
    }
  },
  mounted () {
    this.$nextTick(() => {
      const menuList = Lockr.get('menuListLeft')
      this.menuList = menuList ? menuList : this.menuList
      // 刷新时设置当前选中的菜单
      const leftPath = sessionStorage.getItem('leftPath')
      if (leftPath === '/home/export-data') {
        this.pathNow = '/home/data-inout-nav'
      } else {
        this.pathNow = leftPath
      }
    })
  },
  methods: {
    // 回调
    openMenu (index) {
      // console.log(index, 'hahahah')
    },
    // 处理路径
    handlePath (path) {
      const leftMenuList = JSON.parse(JSON.stringify(this.leftMenuList))
      // console.log(leftMenuList, 'leftMenuListleftMenuList')
      leftMenuList.forEach((item, index) => {
        if (item.id === '12') {
          item.children.forEach((one, ix) => {
            if (one.id === '31') {
              console.log(one, '线下活动')
              item.children.splice(ix, 1)
            }
          })
        }
      })
      leftMenuList.forEach((item, index) => {
        if (item.id === '12') {
          item.children.forEach((one, ix) => {
            if (one.id === '28') {
              // console.log(one, '活动管理')
              item.children.splice(ix, 1)
            }
          })
        }
      })
      for (let items of leftMenuList) {
        if (items.children.length > 0) {
          for (let item of items.children) {
            // 便利最后一层children，当最后一层里的route跟浏览器中的路径一致时，把它的父级的children给menuList
            for (let last of item.children) {
              if (last.attributes.route === path) {
                this.menuList = items.children
                let id = ''
                if (this.menuList[0].length!==0) {
                  id = this.menuList[0].id
                }
                this.pathNowIndex = Lockr.get('pathNowIndex') || id
                Lockr.set('menuListLeft', this.menuList)
                break
              }
            }
          }
        }
      }
    },

    changeSubmenu (path, indexId) {
      // console.log(indexId, 'hahah====')
      this.$router.push({ path })
      this.pathNowIndex = indexId
      Lockr.set('pathNowIndex', indexId)
      sessionStorage.setItem('leftPath', path)
    },
  },
}
</script>

<style scoped>
  .menuClass {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
</style>
